import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API_BASE from '../api';

const POSITIONS = ['שוער','בלם','מגן ימין','מגן שמאל','קשר הגנתי','קשר','קשר התקפי','קיצוני ימין','קיצוני שמאל','חלוץ'];

const FOOTBALL_CLUBS = [
  'אגמים נתניה','אום אל פחם','איחוד בני שפרעם','איחוד ג\'סר א-זרקא','איחוד כפר קאסם','איחוד מגאר',
  'אל-חמס נאעורה','אל-חמס פוריידיס','אריאל','באקה אל-גרבייה',
  'בית"ר ירושלים','בית"ר מודיעין','בית"ר נורד ירושלים','בית"ר עפולה','בית"ר רמת גן','בית"ר תל אביב',
  'בית שאן','בני יהודה תל אביב','בני נצרת','בני סח\'נין',
  'גבעת שמואל','גבעתיים',
  'הפועל אום אל פחם','הפועל אור עקיבא','הפועל אחי נצרת','הפועל אילת','הפועל אירוני ראשון לציון',
  'הפועל אכסאל','הפועל אלעד','הפועל אריאל','הפועל אשדוד','הפועל אשקלון',
  'הפועל באקה','הפועל באר שבע','הפועל בני ברק','הפועל בני לוד','הפועל בנימינה','הפועל בת ים',
  'הפועל גבעת שמואל','הפועל גבעתיים','הפועל גדרה','הפועל גן יבנה',
  'הפועל דימונה','הפועל הרצליה','הפועל חדרה','הפועל חולון','הפועל חיפה',
  'הפועל טבריה','הפועל טייבה','הפועל טירה','הפועל טירת כרמל',
  'הפועל יבנה','הפועל יהוד','הפועל יוקנעם','הפועל יפו','הפועל ירושלים','הפועל ירכא',
  'הפועל כפר סבא','הפועל כפר שלם','הפועל כפר קאסם','הפועל כרמיאל',
  'הפועל לוד','הפועל מגדל העמק','הפועל מודיעין','הפועל נהריה','הפועל נוף הגליל',
  'הפועל נצרת','הפועל נשר','הפועל נתניה',
  'הפועל עכו','הפועל עפולה','הפועל ערד','הפועל פתח תקווה',
  'הפועל צפת','הפועל קטמון ירושלים','הפועל קריית אונו','הפועל קריית גת',
  'הפועל קריית מוצקין','הפועל קריית שמונה',
  'הפועל ראשון לציון','הפועל רחובות','הפועל רמלה','הפועל רמת גן','הפועל רמת השרון',
  'הפועל שפרעם','הפועל תל אביב','הפועל תל מונד','הפועל תמרה',
  'זכרון יעקב','כפר כנא','כפר מנדא','כפר קרע',
  'מ.ס. אשדוד','מ.ס. כביר','מ.ס. כנעאן',
  'מכבי אום אל פחם','מכבי אור יהודה','מכבי אחי נצרת','מכבי אחיעזר','מכבי אילת',
  'מכבי אירוני ראשון לציון','מכבי אכסאל','מכבי אלעד','מכבי אריאל','מכבי אשדוד','מכבי אשקלון',
  'מכבי בית שאן','מכבי בית שמש','מכבי בני ברק','מכבי בת ים',
  'מכבי גדרה','מכבי גן יבנה','מכבי גני תקווה',
  'מכבי הרצליה','מכבי זכרון יעקב','מכבי חדרה','מכבי חולון','מכבי חיפה',
  'מכבי טבריה','מכבי טייבה','מכבי טירה','מכבי טירת כרמל',
  'מכבי יבנה','מכבי יהוד','מכבי יוקנעם','מכבי יפו','מכבי ירכא',
  'מכבי כפר בר','מכבי כפר ברא','מכבי כפר כנא','מכבי כפר מנדא','מכבי כפר סבא','מכבי כפר קאסם',
  'מכבי כרמיאל','מכבי לוד','מכבי מגדל העמק','מכבי מגדל שמס','מכבי מודיעין',
  'מכבי נהריה','מכבי נוף הגליל','מכבי נצרת','מכבי נשר','מכבי נתניה',
  'מכבי עכו','מכבי עפולה','מכבי פתח תקווה',
  'מכבי צפת','מכבי קטמון ירושלים','מכבי קריית גת','מכבי קריית מוצקין','מכבי קריית שמונה',
  'מכבי ראשון לציון','מכבי רחובות','מכבי רמלה','מכבי רמת גן','מכבי רמת השרון',
  'מכבי שפרעם','מכבי תל אביב','מכבי תמרה',
  'עירוני אשדוד','עירוני טבריה','עירוני ירושלים','עירוני כנרות','עירוני קריית שמונה','עירוני רמת השרון',
  'פועלי נצרת','ריינה','שמשון תל אביב',
].sort((a,b) => a.localeCompare(b, 'he'));

export default function OrderForm() {
  const { templateId } = useParams();
  const [formSettings, setFormSettings] = useState({ price: 0, product_name: '', mode: 'manual' });
  useEffect(() => {
    const url = templateId
      ? API_BASE + '/form-templates/' + templateId
      : API_BASE + '/form-settings';
    fetch(url).then(r=>r.json()).then(d => setFormSettings(d)).catch(()=>{});
  }, [templateId]);

  const [form, setForm] = useState({
    first_name:'', last_name:'', phone:'', email:'',
    child_name:'', child_last_name:'', child_dob:'', dob_day:'', dob_month:'', dob_year:'', team:'',
    positions:'', jersey_number:'', opponent_team:'', full_game: true, played_until:'', notes:'', marketing_consent: true
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const togglePosition = p => {
    const cur = form.positions ? form.positions.split(',').map(s=>s.trim()).filter(Boolean) : [];
    const next = cur.includes(p) ? cur.filter(x=>x!==p) : [...cur, p];
    set('positions', next.join(', '));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!form.first_name || !form.phone || !form.child_name) {
      setError('יש למלא שם פרטי, טלפון ושם השחקן');
      return;
    }
    setLoading(true);
    try {
      await fetch(API_BASE + '/customers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          product_interest: formSettings.product_name || 'קליפ ביצועים',
          product_price: formSettings.price || 0,
          notes: [
            form.notes,
            form.game_type === 'full' ? 'סוג משחק: משחק מלא' : form.game_type === 'multiple' ? 'סוג משחק: מספר משחקים מלאים' : form.game_type === 'clips' ? 'סוג משחק: קטעים ממשחקים שונים' : form.full_game ? 'זמן משחק: משחק מלא' : form.played_until ? `שיחק עד דקה: ${form.played_until}` : ''
          ].filter(Boolean).join(' | ')
        })
      });
      setDone(true);
    } catch {
      setError('שגיאה בשליחה, נסה שוב');
    }
    setLoading(false);
  };

  if (done) return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg,#060d1e,#0a1530)', display:'flex', alignItems:'center', justifyContent:'center', direction:'rtl', padding:20, fontFamily:'Heebo, sans-serif' }}>
      <div style={{ background:'rgba(5,15,40,0.95)', border:'1px solid rgba(212,175,55,0.3)', borderRadius:20, padding:'48px 36px', maxWidth:480, width:'100%', textAlign:'center', backdropFilter:'blur(4px)' }}>
        <div style={{ fontSize:'3rem', marginBottom:16 }}>🎬</div>
        <h2 style={{ color:'#d4af37', fontWeight:900, fontSize:'1.7rem', marginBottom:14 }}>תודה שמילאת את הפרטים!</h2>
        <p style={{ color:'#c0cce6', lineHeight:1.9, marginBottom:28 }}>
          ברגע שהקליפ יהיה מוכן תקבלו הודעת וואטסאפ 💬
        </p>
        <a href="/" style={{ display:'inline-block', background:'linear-gradient(135deg,#d4af37,#f0cc60)', color:'#0a1120', fontWeight:800, padding:'13px 32px', borderRadius:12, textDecoration:'none', fontSize:'1rem' }}>
          ⭐ בקרו בליגת הכוכבים של יוסטאר
        </a>
      </div>
    </div>
  );

  return (
    <div className="form-section" style={{ minHeight:'100vh', backgroundImage:"url('/stadium-dark.jpg')", fontFamily:'Heebo, sans-serif', direction:'rtl' }}>
      <div className="section-inner" style={{ paddingTop:0 }}>
        <div className="form-box">

          {/* כותרת */}
          <h2 style={{ fontSize:'clamp(1.3rem,4vw,1.7rem)', marginBottom:10 }}>🎬 טופס הזמנת קליפ ביצועים</h2>
          <p className="subtitle" style={{ marginBottom: formSettings.price > 0 ? 16 : 28 }}>
            הפרטים המלאים חשובים לתחילת עריכת הקליפ
          </p>

          {/* מחיר */}
          {formSettings.price > 0 && (
            <div style={{ background:'rgba(212,175,55,0.1)', border:'1px solid rgba(212,175,55,0.35)', borderRadius:10, padding:'11px 16px', marginBottom:24, textAlign:'center' }}>
              <span style={{ color:'#c0cce6', fontSize:'0.9rem' }}>{formSettings.product_name} — </span>
              <strong style={{ color:'#d4af37', fontSize:'1.15rem' }}>₪{formSettings.price}</strong>
            </div>
          )}

          {error && <div className="alert alert-error" style={{ background:'rgba(255,80,80,0.1)', border:'1px solid rgba(255,80,80,0.35)', borderRadius:8, padding:'10px 14px', color:'#ff8888', marginBottom:16, textAlign:'center' }}>{error}</div>}

          <form onSubmit={handleSubmit}>

            {/* ── פרטי ההורה ── */}
            <div className="form-step-label"><span className="step-num">1</span> פרטי ההורה</div>
            <div className="form-row">
              <div className="form-group">
                <label>שם פרטי *</label>
                <input value={form.first_name} onChange={e=>set('first_name',e.target.value)} placeholder="שם פרטי" />
              </div>
              <div className="form-group">
                <label>שם משפחה</label>
                <input value={form.last_name} onChange={e=>set('last_name',e.target.value)} placeholder="שם משפחה" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>טלפון נייד *</label>
                <input value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="05X-XXXXXXX" type="tel" />
              </div>
              <div className="form-group">
                <label>כתובת אימייל</label>
                <input value={form.email} onChange={e=>set('email',e.target.value)} placeholder="example@email.com (לא חובה)" type="email" />
              </div>
            </div>

            {/* ── פרטי השחקן ── */}
            <div className="form-step-label" style={{ marginTop:20 }}><span className="step-num">2</span> פרטי השחקן</div>
            <div className="form-row">
              <div className="form-group">
                <label>שם פרטי *</label>
                <input value={form.child_name} onChange={e=>set('child_name',e.target.value)} placeholder="שם פרטי" />
              </div>
              <div className="form-group">
                <label>שם משפחה</label>
                <input value={form.child_last_name} onChange={e=>set('child_last_name',e.target.value)} placeholder="שם משפחה" />
              </div>
            </div>

            {/* תאריך לידה */}
            <div className="form-group">
              <label>תאריך לידה</label>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1.5fr', gap:8 }}>
                {[
                  { key:'dob_day',   placeholder:'יום',             maxVal:31 },
                  { key:'dob_month', placeholder:'חודש',            maxVal:12 },
                  { key:'dob_year',  placeholder:"שנה (לדוג׳ 2014)", maxVal:new Date().getFullYear() },
                ].map(({ key, placeholder, maxVal }) => (
                  <input key={key} type="number" inputMode="numeric"
                    placeholder={placeholder} min="1" max={maxVal}
                    value={form[key] || ''}
                    style={{ textAlign:'center' }}
                    onChange={e => {
                      const v = e.target.value;
                      set(key, v);
                      const day   = key==='dob_day'   ? v : form.dob_day;
                      const month = key==='dob_month' ? v : form.dob_month;
                      const year  = key==='dob_year'  ? v : form.dob_year;
                      if (day && month && year && String(year).length === 4)
                        set('child_dob', `${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`);
                    }}
                  />
                ))}
              </div>
            </div>

            <div className="form-group">
              <label>קבוצה</label>
              <select value={form.team} onChange={e=>set('team',e.target.value)}
                style={{ width:'100%', padding:'11px 14px', border:'1px solid rgba(212,175,55,0.3)', borderRadius:8, background:'rgba(255,255,255,0.07)', color: form.team ? '#fff' : '#666', fontSize:'0.95rem', direction:'rtl', fontFamily:'Heebo, sans-serif' }}>
                <option value="">-- בחר קבוצה --</option>
                {FOOTBALL_CLUBS.map(c => <option key={c} value={c}>{c}</option>)}
                <option value="אחר">אחר (לא ברשימה)</option>
              </select>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>מספר חולצה</label>
                <input value={form.jersey_number} onChange={e=>set('jersey_number',e.target.value)} placeholder="7" type="number" />
              </div>
              <div className="form-group">
                <label>יריבה (אופציונלי)</label>
                <input value={form.opponent_team} onChange={e=>set('opponent_team',e.target.value)} placeholder="שם הקבוצה היריבה" />
              </div>
            </div>

            {/* סוג משחק */}
            <div className="form-group">
              <label>סוג משחק</label>
              <div style={{ display:'flex', flexDirection:'column', gap:10, marginTop:4 }}>
                {[
                  { value:'full', label:'משחק מלא' },
                  { value:'multiple', label:'מספר משחקים מלאים' },
                  { value:'clips', label:'קטעים ממשחקים שונים' },
                ].map(({ value, label }) => (
                  <label key={value} style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer', color:'#c0cce6', fontSize:'0.9rem', fontWeight:400 }}>
                    <input type="radio" checked={(form.game_type || 'full') === value} onChange={()=>set('game_type', value)}
                      style={{ accentColor:'#d4af37', width:17, height:17, flexShrink:0 }} />
                    {label}
                  </label>
                ))}
              </div>
            </div>

            {/* עמדות */}
            <div className="form-group">
              <label>עמדה/ות בשטח</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:4 }}>
                {POSITIONS.map(p => {
                  const selected = form.positions?.includes(p);
                  return (
                    <button key={p} type="button" onClick={() => togglePosition(p)}
                      style={{ padding:'7px 14px', borderRadius:20, border:'1px solid', fontSize:'0.82rem', cursor:'pointer', fontFamily:'Heebo, sans-serif', transition:'all 0.15s',
                        background: selected ? 'linear-gradient(135deg,#d4af37,#f0cc60)' : 'rgba(255,255,255,0.05)',
                        borderColor: selected ? '#d4af37' : 'rgba(212,175,55,0.25)',
                        color: selected ? '#000' : '#c0cce6',
                        fontWeight: selected ? 700 : 400,
                      }}>
                      {p}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* הערות */}
            <div className="form-group">
              <label>הערות נוספות</label>
              <textarea value={form.notes} onChange={e=>set('notes',e.target.value)}
                placeholder="פרטים נוספים שחשוב לנו לדעת..."
                style={{ width:'100%', padding:'11px 14px', border:'1px solid rgba(212,175,55,0.3)', borderRadius:8, background:'rgba(255,255,255,0.07)', color:'#fff', fontSize:'0.95rem', direction:'rtl', fontFamily:'Heebo, sans-serif', minHeight:80, resize:'vertical', boxSizing:'border-box' }} />
            </div>

            {/* הסכמה שיווקית */}
            <div className="checkbox-group" style={{ background:'rgba(212,175,55,0.07)', border:'1px solid rgba(212,175,55,0.2)', borderRadius:10, padding:'12px 14px', marginBottom:20 }}>
              <label style={{ color:'#c0cce6', fontSize:'0.88rem', lineHeight:1.6, cursor:'pointer' }}>
                <input type="checkbox" checked={form.marketing_consent} onChange={e=>set('marketing_consent',e.target.checked)}
                  style={{ accentColor:'#d4af37', marginTop:3 }} />
                אני מאשר/ת לקבל עדכונים על מוצרי יוסטאר, מבצעים והצעות מיוחדות בווצאפ ובאימייל.{' '}
                <span style={{ color:'#8a9aba', fontSize:'0.82rem' }}>(ניתן לבטל בכל עת)</span>
              </label>
            </div>

            <button type="submit" disabled={loading}
              style={{ width:'100%', background:'linear-gradient(135deg,#d4af37,#f0cc60)', color:'#0a1120', fontWeight:900, fontSize:'1.05rem', padding:'15px', borderRadius:12, border:'none', cursor:loading?'not-allowed':'pointer', fontFamily:'Heebo, sans-serif', display:'flex', flexDirection:'column', alignItems:'center', gap:4, lineHeight:1.4 }}>
              {loading ? '...שולח' : '🎬 שלחו פרטים וצוות יוסטאר יתחיל לעבוד על הקליפ'}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}
